import { Card, CardBody } from '../../../../components/card/card';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import useGetEquipmentsList from '../../../../hooks/FLeet/useGetEquipmentsList';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';
import useLookupFleetInspectionType from '@hooks/Lookups/use-Lookup-FleetInspectionType';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const Index = () => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const Navigate = useNavigate();
  const { FleetInspectionTypeOptions } = useLookupFleetInspectionType();
  const { EquipmentsList, loading } = useGetEquipmentsList();

  //________________________________

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Plate_Number'), key: 'Plate_Number' },
    { title: t('AssetNumber'), key: 'AssetNumber' },
    { title: t('ServiceDate'), key: 'ServiceDate' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = EquipmentsList?.slice()
    ?.sort((a, b) => {
      // وضع العناصر التي لها peopleName أولاً
      const hasPeopleNameA = a.peopleName !== null || a.peopleName2 !== null;
      const hasPeopleNameB = b.peopleName !== null || b.peopleName2 !== null;

      if (hasPeopleNameA && !hasPeopleNameB) return -1;
      if (!hasPeopleNameA && hasPeopleNameB) return 1;
      return 0;
    })
    ?.map(item => {
      let rowClass;

      return {
        Name: (
          <div className='d-flex align-items-center'>
            <div className='w-50px h-50px bg-white bg-opacity-25 d-flex align-items-center justify-content-center'>
              {item.image === null ? (
                <img alt='' className='mw-100 mh-100' src='/assets/img/Image/NoImg2.ico' />
              ) : (
                <img
                  alt=''
                  className='mw-100 mh-100' //img-fluid
                  src={item?.image?.filePath}
                />
              )}
            </div>
            <div className='ms-3'>{i18n.language === 'en' ? item.name : item.name2}</div>
          </div>
        ),
        Plate_Number: item.plateNo,
        AssetNumber: item.code,
        ServiceDate: item.serviceDate,
        action: (
          <div className='d-flex justify-content-end gap-2'>
            <div className='btn-group'>
              <div className='btn-group' role='group' dir={isRTL ? 'rtl' : 'ltr'}>
                {HasPermission('FleetNewCheck') && (
                  <button
                    hidden={item.peopleName === null && item.peopleName2 === null}
                    type='button'
                    className='btn btn-theme dropdown-toggle me-2'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                    aria-label={t('NewMaintenanceOrder')}
                    title={t('NewMaintenanceOrderTooltip')}
                  >
                    {t('NewScan')}
                  </button>
                )}

                <ul
                  className={`dropdown-menu ${isRTL ? 'dropdown-menu-end' : 'dropdown-menu-start'}`}
                  style={{ textAlign: isRTL ? 'right' : 'left' }}
                >
                  {FleetInspectionTypeOptions?.map((type: any, index: any) => (
                    <li key={type.value}>
                      <Link className='dropdown-item d-flex align-items-center' to={`${item.id}/${type.value}/AddScan`}>
                        <i
                          className={`bi bi-lightning fa-lg ${isRTL ? 'me-2' : 'ms-2'} text-theme`}
                          aria-hidden='true'
                        />
                        {type.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              {HasPermission('FleetListPreviousExaminations') && (
                <button
                  type='button'
                  className='btn btn-sm btn-theme me-2'
                  data-toggle='tooltip'
                  title='Scannig List'
                  onClick={() => Navigate(`${item.id}/ScanningList`)}
                >
                  <i className='fa-lg bi bi-list me-2'></i>
                  {t('PreviousInspections')}
                </button>
              )}
            </div>
          </div>
        ),
        // ?.filter(f => f.peopleName)??

        rowClass // استخدم rowClass هنا
      };
    });

  //________________________________

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
           link: ':moduleHome'
          },
          {
            name: 'EquipmentInspection',
            link: null
          }
        ]}
        PageName='EquipmentInspection'
      />

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>
    </div>
  );
};

export default Index;
